import * as React from "react";
import { useTranslation } from "react-i18next";
import { StyledButton } from "../../atoms/button";
import MessageLayout from '../../templetes/messageLayout'
import './style.scss'
const Alert = () => {
  const { t } = useTranslation();
  React.useEffect(() => {
    window.alert = showAlert
  }, [])
  return (
    <div id="AlertPopup" className="popup-layout-wrap">
      <div className='layout-table' theme='primary'>
        <MessageLayout
          closePopup={closeAlert}
          theme='primary'
          title={t("common.alert")}
          button={
            <StyledButton type='text' data-bg='primary' size='md' onClick={closeAlert}>
              {t("common.ok")}
            </StyledButton>
          }>
          <div id="alertBody">

          </div>
        </MessageLayout>
      </div>
    </div>
  );
};

export default Alert;

const showAlert = (message) => {
  if (!document.getElementById("AlertPopup").classList.contains("on")) {
    let text = message;
    if (message != null && typeof message !== 'string') {
      text = message.message || message.error || message.errorMessage || JSON.stringify(message);
    }
    document.getElementById("alertBody").innerText = text != null ? String(text) : '';
    document.getElementById("AlertPopup").classList.add("on")
  }
}
const closeAlert = () => {
  if (document.getElementById("AlertPopup").classList.contains("on")) {
    document.getElementById("AlertPopup").classList.remove("on")
  }
}
